export default __webpack_public_path__ + "static/media/list-section-header.5e4f2f06.jpg";